import { render, staticRenderFns } from "./yz_ws_zhengju.vue?vue&type=template&id=245f825e&scoped=true"
import script from "./yz_ws_zhengju.vue?vue&type=script&lang=js"
export * from "./yz_ws_zhengju.vue?vue&type=script&lang=js"
import style0 from "./yz_ws_zhengju.vue?vue&type=style&index=0&id=245f825e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245f825e",
  null
  
)

export default component.exports